import { addDays, endOfToday, startOfDay } from 'date-fns';
import { create } from 'zustand';

import { ReturnRequestStatus } from 'types';

const DEFAULT_PAST_SELECTION = -89;
const DEFAULT_START_DATE = () =>
  startOfDay(addDays(new Date(), DEFAULT_PAST_SELECTION));
const DEFAULT_END_DATE = () => endOfToday();

interface ReturnsRefundsFiltersStore {
  startDate: Date;
  endDate: Date;
  statuses: ReturnRequestStatus;
  setFilters: (
    filters: Partial<
      Pick<ReturnsRefundsFiltersStore, 'startDate' | 'endDate' | 'statuses'>
    >
  ) => void;
  resetFilters: () => void;
}

const getDefaultValues = (): Pick<
  ReturnsRefundsFiltersStore,
  'startDate' | 'endDate' | 'statuses'
> => ({
  startDate: DEFAULT_START_DATE(),
  endDate: DEFAULT_END_DATE(),
  statuses: ReturnRequestStatus.Open,
});

export const useReturnsRefundsFiltersStore = create<ReturnsRefundsFiltersStore>(
  set => ({
    ...getDefaultValues(),
    setFilters: filters => set(state => ({ ...state, ...filters })),
    resetFilters: () =>
      set(state => ({
        ...state,
        startDate: DEFAULT_START_DATE(),
        endDate: DEFAULT_END_DATE(),
      })),
  })
);
